<script>
	import Siema from 'siema'
	import { onMount } from 'svelte'
	import { tweened } from 'svelte/motion'
	import { cubicOut } from 'svelte/easing'
	import { fade, fly } from 'svelte/transition'
	export let team = []

	let teamWrap

	let index = 0
	let activeItem = team[index]

	let mounted
	let next
	let previous
	let myinternval
	let myinternval2
	let siema
	let click

	let items

	const height = tweened(0, {
		duration: 500,
		easing: cubicOut,
	})

	function setHeight(node) {
		if (!node) {
			node = document.querySelector('.team-content > div')
		}
		if (!mounted) {
			height.set(node.clientHeight, {
				duration: 0,
			})
			mounted = true
		} else {
			$height = node.clientHeight
		}
	}

	onMount(() => {
		siema = new Siema({
			selector: teamWrap,
			duration: 400,
			loop: true,
			perPage: {
				0: 1,
				400: 2,
				900: 4,
				1600: 5,
			},
		})
		myinternval = setInterval(() => siema.next(), 6000) // set interval of slider
		myinternval2 = setInterval(() => {
			//set internval of content box
			if (team.length - 1 == index) {
				index = 0
			} else {
				index++
			}
			activeItem = team[index]
		}, 6000)
		next = function next() {
			siema.next()
			if (team.length - 1 == index) {
				index = 0
			} else {
				index++
			}
			activeItem = team[index]
			clearInterval(myinternval)
			clearInterval(myinternval2)
		}

		previous = function previous() {
			siema.prev()
			if (index == 0) {
				index = team.length - 1
			} else {
				index--
			}
			activeItem = team[index]
			clearInterval(myinternval)
			clearInterval(myinternval2)
		}

		items = document.querySelectorAll('.team-item')
		items.forEach(item => {
			item.addEventListener('click', function(e) {
				let slideIndex = item.getAttribute('data-index')
				siema.goTo(slideIndex)
				activeItem = team[slideIndex]
				index = slideIndex
				clearInterval(myinternval)
				clearInterval(myinternval2)
			})
		})
	})
</script>

<div class="team-wrap">
	<div class="team-wrap-controls">
		<button
			class="t-prev"
			on:click={previous}
			aria-label="Previous Team Member">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 16.4 32.7"
				style="transform: scaleX(-1)">
				<path
					d="M0 0c4.2 10.5 4.2 22.2 0 32.7l16.4-16.4L0 0z"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#fff" />
			</svg>
		</button>
		<button class="t-next" on:click={next} aria-label="Next Team Member">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 16.4 32.7">
				<path
					d="M0 0c4.2 10.5 4.2 22.2 0 32.7l16.4-16.4L0 0z"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#fff" />
			</svg>
		</button>
	</div>
	<div class="team-wrap-inner" bind:this={teamWrap}>
		{#each team as item, i}
			<div class="team-item" data-index={i}>
				<div
					class="team-image {item.image ? '' : 'team-image-fallback'}"
					style="background-image: url({item.image})" />
			</div>
		{/each}
	</div>
	<div class="team-wrap-active">
		<div class="team-wrap-active-inner" style="padding-bottom:{$height}px">
			{#each [activeItem] as item (item.name)}
				<div class="team-content">
					<div in:fly={{ y: 200, duration: 1000 }} out:fade use:setHeight>
						<h2>
							{@html item.name}
						</h2>
						<h3>
							{@html item.title}
						</h3>
						{@html item.content}
					</div>
				</div>
			{/each}
		</div>
	</div>
</div>
